export default __webpack_public_path__ + "static/media/job-board-permanent-job.702f3857.jpg";